// extracted by mini-css-extract-plugin
module.exports = {"bell":"NotificationBell_bell__AUFez"};